import { GlobalFilterListItem } from '../../../integrated-client/models/';

interface ITableData {
  records: Array<GlobalFilterListItem>;
  totalItems?: number;
}

export class TableData implements ITableData {
  records: Array<GlobalFilterListItem>;
  totalItems?: number;

  constructor() {
    this.records = [];
  }
}
